import { defineStore } from 'pinia'
import { supabase } from '@/supabase'

export const useAuthStore = defineStore('auth', {
  state: () => ({
    is: false,
    user: null
  }),
  actions: {
    async logout() {
      await supabase.auth.signOut()
      this.user = null
      this.is = false
    },
    setIs(data) {
      this.is = data;
    },
    setUser(data) {
      this.user = data;
    }
  }
});